

// import React, { useState, useEffect } from 'react';
// import { Menu, X } from 'lucide-react'; // Ensure: npm install lucide-react
// import './Navbar.css';
// import { Link } from 'react-router-dom';

// import logo from '../Images/logo.png'; // Update path if needed

// const Navbar = () => {
//   const [isScrolled, setIsScrolled] = useState(false);
//   const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

//   // Handle Scroll Effect (Transparent to White)

// const [showNavbar, setShowNavbar] = useState(true);

// useEffect(() => {
//   let lastScrollY = window.scrollY;

//   const handleScroll = () => {
//     const currentScrollY = window.scrollY;

//     // White background after scroll
//     setIsScrolled(currentScrollY > 50);

//     // Show / hide navbar based on scroll direction
//     if (currentScrollY > lastScrollY && currentScrollY > 100) {
//       // scrolling down
//       setShowNavbar(false);
//     } else {
//       // scrolling up
//       setShowNavbar(true);
//     }

//     lastScrollY = currentScrollY;
//   };

//   window.addEventListener('scroll', handleScroll, { passive: true });
//   return () => window.removeEventListener('scroll', handleScroll);
// }, []);

//   // Close mobile menu when a link is clicked
//   const closeMobileMenu = () => setMobileMenuOpen(false);

//   return (
//    <nav className={`navbar ${isScrolled ? 'scrolled' : ''} ${showNavbar ? 'show' : 'hide'}`}>

//       <div className="container nav-content">
        
//         {/* --- Logo Section --- */}
//         <div className="logo">
//           <img src={logo} alt="Property Galleria" className="logo-img" />
//         </div>

//         {/* --- Desktop Navigation (Hidden on Mobile) --- */}
//        <div className="nav-links desktop-menu">
//   {['Home', 'About', 'Services', 'Properties', 'Contact'].map((item) => {
//     const path = item === 'Home' ? '/' : `/${item.toLowerCase()}`;
//     return (
//       <Link key={item} to={path} className="nav-link">
//         {item}
//       </Link>
//     );
//   })}
// </div>


//         {/* --- Mobile Toggle Button (Visible only on Mobile) --- */}
//         <div className="mobile-toggle" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
//           {mobileMenuOpen ? (
//             // Close Icon (Always dark inside the white menu overlay, or dynamic based on scroll)
//             <X size={32} color={mobileMenuOpen ? '#1a1a1a' : (isScrolled ? '#1a1a1a' : '#ffffff')} />
//           ) : (
//             // Hamburger Icon (White on transparent hero, Dark on scrolled white navbar)
//             <Menu size={32} color={isScrolled ? '#1a1a1a' : '#8b306d'} />
//           )}
//         </div>

//         {/* --- Mobile Full-Screen Menu Overlay --- */}
// <div className={`mobile-menu ${mobileMenuOpen ? 'active' : ''}`}>
//   {['Home', 'About', 'Services', 'Properties', 'Contact'].map((item) => {
//     const path = item === 'Home' ? '/' : `/${item.toLowerCase()}`;
//     return (
//       <Link 
//         key={item} 
//         to={path} 
//         className="mobile-nav-link"
//         onClick={closeMobileMenu} // closes mobile menu on click
//       >
//         {item}
//       </Link>
//     );
//   })}
// </div>

//       </div>
//     </nav>
//   );
// };

// export default Navbar;




import React, { useState, useEffect } from 'react';
import { Menu, X ,   Home,
  Building,
  Store,
  Factory,
  Leaf,
  Coins,
  ChevronDown} from 'lucide-react'; // Ensure: npm install lucide-react
import './Navbar.css';
import { Link } from 'react-router-dom';

import logo from '../Images/logo.png'; // Update path if needed
import axios from 'axios';



const CATEGORY_API = 'https://api.propertygalleria.in/api/property-categories';

const categoryIconMap = {
  residential: Building,
  commercial: Store,
  industrial: Factory,
  agricultural: Leaf,
  'rental/income': Coins,
};


const toSlug = (value = '') =>
  value
    .toLowerCase()
    .trim()
    .replace(/\s*\/\s*/g, '-') // 🔥 FIX
    .replace(/\s+/g, '-');



const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [mobilePropertiesOpen, setMobilePropertiesOpen] = useState(false);
const [categories, setCategories] = useState([]);


useEffect(() => {
  const fetchCategories = async () => {
    try {
      const res = await fetch(CATEGORY_API);
      const data = await res.json();

      // sort by ID (3,4,5...)
      const sorted = data.sort((a, b) => a.id - b.id);
      setCategories(sorted);
    } catch (err) {
      console.error('Failed to load property categories', err);
    }
  };

  fetchCategories();
}, []);


  // Handle Scroll Effect (Transparent to White)

const [showNavbar, setShowNavbar] = useState(true);

useEffect(() => {
  let lastScrollY = window.scrollY;

  const handleScroll = () => {
    const currentScrollY = window.scrollY;

    // White background after scroll
    setIsScrolled(currentScrollY > 50);

    // Show / hide navbar based on scroll direction
    if (currentScrollY > lastScrollY && currentScrollY > 100) {
      // scrolling down
      setShowNavbar(false);
    } else {
      // scrolling up
      setShowNavbar(true);
    }

    lastScrollY = currentScrollY;
  };

  window.addEventListener('scroll', handleScroll, { passive: true });
  return () => window.removeEventListener('scroll', handleScroll);
}, []);

  // Close mobile menu when a link is clicked
  const closeMobileMenu = () => setMobileMenuOpen(false);

  //text train

    const [data, setData] = useState([]);
    const [filter, setFilter] = useState("ALL");
  
    // Load data from API
    // const loadData = async () => {
    //   try {
    //     const res = await axios.get("https://api.propertygalleria.in/master/api/greetings");
    //     setData(res.data);
    //   } catch (error) {
    //     console.error("Error loading greetings", error);
    //   }
    // };
  
  const loadData = async () => {
    try {
      const res = await axios.get(
        "https://api.propertygalleria.in/master/api/greetings"
      );

      // Filter only valid messages
      const filtered = res.data.filter(
        (item) => item.message && item.message !== "\\N"
      );

      setData(filtered);
    } catch (error) {
      console.error("Error loading greetings", error);
    }
  };

    useEffect(() => {
      loadData();
    }, []);

    const handleNavigation = (url) => {
    if (!url || url === "\\N") return;

    const finalUrl = url.startsWith("http")
      ? url
      : `https://${url}`;

    window.open(finalUrl, "_blank");
  };


  return (
    <>
   <nav className={`navbar ${isScrolled ? 'scrolled' : ''} ${showNavbar ? 'show' : 'hide'}`}>

      <div className="container nav-content">
        
        {/* --- Logo Section --- */}
        <div className="logo">
          <img src={logo} alt="Property Galleria" className="logo-img" />
        </div>

        {/* --- Desktop Navigation (Hidden on Mobile) --- */}
       {/* <div className="nav-links desktop-menu">
  {['Home', 'About', 'Services', 'Properties', 'Contact'].map((item) => {
    const path = item === 'Home' ? '/' : `/${item.toLowerCase()}`;
    return (
      <Link key={item} to={path} className="nav-link">
        {item}
      </Link>
    );
  })}
</div> */}

<div className="nav-links desktop-menu">

  {/* Home */}
  <Link to="/" className="nav-link">Home</Link>

  {/* About */}
  <Link to="/about" className="nav-link">About</Link>

  {/* Services */}
  <Link to="/services" className="nav-link">Services</Link>

  {/* Properties Dropdown */}
  <div className="nav-item dropdown">
    <span className="nav-link">Properties</span>

  {/* <div className="dropdown-menu">
  <Link to="/property/residential">
    <Building size={16} />
    <span>Residential</span>
  </Link>

  <Link to="/property/commercial">
    <Store size={16} />
    <span>Commercial</span>
  </Link>

  <Link to="/property/industrial">
    <Factory size={16} />
    <span>Industrial</span>
  </Link>

  <Link to="/property/agricultural">
    <Leaf size={16} />
    <span>Agricultural</span>
  </Link>

  <Link to="/property/rental">
    <Coins size={16} />
    <span>Rental / Income</span>
  </Link>
</div> */}

<div className="dropdown-menu">
  {categories.map((cat) => {
      const slug = toSlug(cat.category_name);
    const Icon = categoryIconMap[cat.category_name.toLowerCase()];

    console.log("slg",slug)

    return (
      <Link key={cat.id} to={`/property/${slug}`}>
        {Icon && <Icon size={16} />}
        <span>{cat.category_name}</span>
      </Link>
    );
  })}
</div>


  </div>

  {/* Contact */}
  <Link to="/contact" className="nav-link">Contact</Link>
 <Link to="/mainlandingpage" className="nav-link">Login</Link>

</div>


        {/* --- Mobile Toggle Button (Visible only on Mobile) --- */}
        <div className="mobile-toggle" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
          {mobileMenuOpen ? (
            // Close Icon (Always dark inside the white menu overlay, or dynamic based on scroll)
            <X size={32} color={mobileMenuOpen ? '#1a1a1a' : (isScrolled ? '#1a1a1a' : '#ffffff')} />
          ) : (
            // Hamburger Icon (White on transparent hero, Dark on scrolled white navbar)
            <Menu size={32} color={isScrolled ? '#1a1a1a' : '#8b306d'} />
          )}
        </div>

        {/* --- Mobile Full-Screen Menu Overlay --- */}
{/* <div className={`mobile-menu ${mobileMenuOpen ? 'active' : ''}`}>
  {['Home', 'About', 'Services', 'Properties', 'Contact'].map((item) => {
    const path = item === 'Home' ? '/' : `/${item.toLowerCase()}`;
    return (
      <Link 
        key={item} 
        to={path} 
        className="mobile-nav-link"
        onClick={closeMobileMenu} // closes mobile menu on click
      >
        {item}
      </Link>
    );
  })}
</div> */}

{/* <div className={`mobile-menu ${mobileMenuOpen ? 'active' : ''}`}>

  <Link to="/" className="mobile-nav-link" onClick={closeMobileMenu}>Home</Link>
  <Link to="/about" className="mobile-nav-link" onClick={closeMobileMenu}>About</Link>
  <Link to="/services" className="mobile-nav-link" onClick={closeMobileMenu}>Services</Link>

<div className="mobile-properties">

  <button
    className="mobile-properties-toggle"
    onClick={() => setMobilePropertiesOpen(!mobilePropertiesOpen)}
  >
    <span>Properties</span>
    <svg
      className={`chevron ${mobilePropertiesOpen ? 'open' : ''}`}
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M6 9l6 6 6-6"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </button>

  <div className={`mobile-properties-menu ${mobilePropertiesOpen ? 'open' : ''}`}>
    <Link to="/property/residential" onClick={closeMobileMenu}>
      <Building size={18} />
      <span>Residential</span>
    </Link>

    <Link to="/property/commercial" onClick={closeMobileMenu}>
      <Store size={18} />
      <span>Commercial</span>
    </Link>

    <Link to="/property/industrial" onClick={closeMobileMenu}>
      <Factory size={18} />
      <span>Industrial</span>
    </Link>

    <Link to="/property/agricultural" onClick={closeMobileMenu}>
      <Leaf size={18} />
      <span>Agricultural</span>
    </Link>

    <Link to="/property/rental" onClick={closeMobileMenu}>
      <Coins size={18} />
      <span>Rental / Income</span>
    </Link>
  </div>

</div>



  <Link to="/contact" className="mobile-nav-link" onClick={closeMobileMenu}>Contact</Link>

</div> */}
{/* === Mobile Slide Menu === */}
<div className={`mobile-panel ${mobileMenuOpen ? 'open' : ''}`}>

  <div className="mobile-panel-header">
    <img src={logo} alt="Property Galleria" />
    <button onClick={() => setMobileMenuOpen(false)}>
      <X size={26} />
    </button>
  </div>

  <div className="mobile-panel-links">

    <Link to="/" onClick={closeMobileMenu}>Home</Link>
    <Link to="/about" onClick={closeMobileMenu}>About</Link>
    <Link to="/services" onClick={closeMobileMenu}>Services</Link>

    {/* Properties Accordion */}
    <div className={`accordion ${mobilePropertiesOpen ? 'open' : ''}`}>

      <button
        className="accordion-toggle"
        onClick={() => setMobilePropertiesOpen(!mobilePropertiesOpen)}
      >
        <span>Properties</span>
        <ChevronDown size={20} />
      </button>

      {/* <div className="accordion-content">
        <Link to="/property/residential" onClick={closeMobileMenu}>
          <Building /> Residential
        </Link>
        <Link to="/property/commercial" onClick={closeMobileMenu}>
          <Store /> Commercial
        </Link>
        <Link to="/property/industrial" onClick={closeMobileMenu}>
          <Factory /> Industrial
        </Link>
        <Link to="/property/agricultural" onClick={closeMobileMenu}>
          <Leaf /> Agricultural
        </Link>
        <Link to="/property/rental" onClick={closeMobileMenu}>
          <Coins /> Rental / Income
        </Link>
      </div> */}

      <div className="accordion-content">
  {categories.map((cat) => {
      const slug = toSlug(cat.category_name);
    const Icon = categoryIconMap[cat.category_name.toLowerCase()];

    return (
      <Link
        key={cat.id}
        to={`/property/${slug}`}
        onClick={closeMobileMenu}
      >
        {Icon && <Icon size={18} />}
        {cat.category_name}
      </Link>
    );
  })}
</div>

    </div>

    <Link to="/contact" onClick={closeMobileMenu}>Contact</Link>
    
 <Link to="/mainlandingpage" className="nav-link">Login</Link>
  </div>
</div>


      </div>

          {/* <div className="train-wrapper"> */}
      {/* <div className="train">
        {data.map((item) => (
          <span key={item.id} className="train-text">
            {item.type} : {item.message} &nbsp;&nbsp;&nbsp; | &nbsp;&nbsp;&nbsp;
          </span>
        ))}
      </div> */}
      {/* <div className="train">
  {[...data, ...data].map((item, index) => (
    <span key={index} className="train-text">
      {item.type} : {item.message} {item.url} &nbsp;&nbsp;&nbsp; | &nbsp;&nbsp;&nbsp;
    </span>
  ))}
</div>

    </div> */}

      <div className="train-wrapper">
      <div className="train">
        {[...data, ...data].map((item, index) => (
          <div key={index} className="train-item">
            <span className="train-text">
              {item.type} : {item.message}
            </span>

            {item.url && item.url !== "\\N" && (
              <span
                className="link-icon"
                onClick={() => handleNavigation(item.url)}
              >
                🔗
              </span>
            )}
          </div>
        ))}
      </div>
    </div>
    </nav>

    </>
  );
};

export default Navbar;